module.exports = __webpack_public_path__ + "static/media/Tulsa.14ae2aec.png";